import { c as _c } from "react/compiler-runtime";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { carePlanTagApi } from "@/api/provider/settings/care-plan-tag";
import { carePlanTagQueryKeys } from "@/api/provider/settings/care-plan-tag-query";
export const useCreateCarePlanTagMutation = () => {
  const $ = _c(2);
  const queryClient = useQueryClient();
  let t0;
  if ($[0] !== queryClient) {
    t0 = {
      mutationFn: _temp,
      onSettled: () => {
        queryClient.invalidateQueries({
          queryKey: carePlanTagQueryKeys.all
        });
      }
    };
    $[0] = queryClient;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  return useMutation(t0);
};
export const useUpdateCarePlanTagMutation = () => {
  const $ = _c(2);
  const queryClient = useQueryClient();
  let t0;
  if ($[0] !== queryClient) {
    t0 = {
      mutationFn: _temp2,
      onSettled: () => {
        queryClient.invalidateQueries({
          queryKey: carePlanTagQueryKeys.all
        });
      }
    };
    $[0] = queryClient;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  return useMutation(t0);
};
export const useDeleteCarePlanTagMutation = () => {
  const $ = _c(2);
  const queryClient = useQueryClient();
  let t0;
  if ($[0] !== queryClient) {
    t0 = {
      mutationFn: _temp3,
      onSettled: () => {
        queryClient.invalidateQueries({
          queryKey: carePlanTagQueryKeys.all
        });
      }
    };
    $[0] = queryClient;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  return useMutation(t0);
};
function _temp(data) {
  return carePlanTagApi.create(data);
}
function _temp2(payload) {
  return carePlanTagApi.update(payload.id, payload.data);
}
function _temp3(id) {
  return carePlanTagApi.delete(id);
}